import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const getUnitMeasurementCatalog = state => state.models[name].unitMeasurements.results;
export const getCurUnitMeasurement = state => state.models[name].unitMeasurement;